import { useState } from 'react';
import { useT } from '../i18n';
import { enableHandPush, lockWheels, useHandPush } from '../lib/handPush';
import { IconHand, IconLock } from './HandPushFab';

/** "✋ Hand push" toggle: off → `handPush {enabled: true}`; on (blue) → "🔒 Lock wheels" → `handPush {enabled: false}`. */
export function HandPushButton({ serial, online, className = '' }: { serial: string; online: boolean; className?: string }) {
  const t = useT();
  const { enabled, pending } = useHandPush(serial);
  return (
    <button
      type="button"
      className={`btn${enabled ? ' hand-on' : ''} ${className}`}
      aria-pressed={enabled}
      disabled={!online || Boolean(pending)}
      onClick={() => void (enabled ? lockWheels(serial) : enableHandPush(serial))}
      title={enabled ? t('hand.lockTitle') : t('hand.title')}
    >
      {pending ? <span className="spinner sm" aria-hidden /> : enabled ? <IconLock size={16} /> : <IconHand size={16} />} <span className="btn-label">{enabled ? t('hand.lock') : t('hand.button')}</span>
    </button>
  );
}

/** Blue banner over the camera with "Lock wheels". */
export function HandPushBanner({ serial }: { serial: string }) {
  const t = useT();
  const { enabled } = useHandPush(serial);
  const [busy, setBusy] = useState(false);
  if (!enabled) return null;
  return (
    <div className="stuck-banner hand" role="status">
      <span className="row" style={{ gap: 8 }}>
        <IconHand size={16} />
        {t('hand.banner')}
      </span>
      <button
        type="button"
        className="btn xs"
        disabled={busy}
        onClick={async () => {
          setBusy(true);
          await lockWheels(serial);
          setBusy(false);
        }}
      >
        <IconLock size={14} /> {t('hand.lock')}
      </button>
    </div>
  );
}
